'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { startAuthAutoRefresh, stopAuthAutoRefresh } from '@/features/auth/store';
import { selectAuthIsAuthenticated } from '@/features/auth/store/selectors';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
export function AuthRefreshProvider(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectAuthIsAuthenticated);
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== isAuthenticated) {
    t1 = () => {
      if (isAuthenticated) {
        dispatch(startAuthAutoRefresh());
        return;
      }
      dispatch(stopAuthAutoRefresh());
    };
    t2 = [dispatch, isAuthenticated];
    $[0] = dispatch;
    $[1] = isAuthenticated;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== children) {
    t3 = <>{children}</>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}